import { render } from "./v-tooltip.vue?vue&type=template&id=1ca4d924"
import script from "./v-tooltip.vue?vue&type=script&lang=js"
export * from "./v-tooltip.vue?vue&type=script&lang=js"

import "./v-tooltip.vue?vue&type=style&index=0&id=1ca4d924&lang=css"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__